import React, { useState, useEffect } from 'react';

const AccountPage = () => {
    const [profile, setProfile] = useState({
        civility: '',
        name: '',
        username: '',
        email: '',
        phone: '',
        photo_url: ''
    });
    const [loadingProfile, setLoadingProfile] = useState(false);
    const [profileError, setProfileError] = useState('');

    useEffect(() => {
        const load = async () => {
            setLoadingProfile(true);
            try {
                const userData = JSON.parse(localStorage.getItem('userData') || '{}');
                const u = userData || {};
                setProfile({
                    civility: '',
                    name: u.name || '',
                    username: u.username || '',
                    email: u.email || '',
                    phone: u.phone || u.phone_national || '',
                    photo_url: u.photo_url || u.photo || ''
                });
            } catch (e) {
                setProfileError("Impossible de charger le profil.");
            } finally {
                setLoadingProfile(false);
            }
        };
        load();
    }, []);

    return (
        <div className="card border-0 shadow-sm" style={{borderRadius: '15px'}}>
            <div className="card-header bg-transparent border-0 p-4">
                <div className="d-flex justify-content-between align-items-center">
                    <div>
                        <h4 className="fw-bold mb-1">
                            <i className="fa fa-cog me-2 text-primary"></i>
                            Paramètres du compte
                        </h4>
                        <p className="text-muted mb-0">Gérez vos informations personnelles</p>
                    </div>
                </div>
            </div>
            <div className="card-body p-4">
                <div className="row">
                    {/* Profile Photo Section */}
                    <div className="col-md-6">
                        <div className="card border-0 shadow-sm" style={{borderRadius: '12px'}}>
                            <div className="card-header bg-transparent border-0">
                                <h6 className="fw-bold mb-0">Photo ou Avatar</h6>
                            </div>
                            <div className="card-body text-center p-4">
                                <div className="avatar-upload mb-3">
                                    <div className="avatar-preview" style={{
                                        width: '120px',
                                        height: '120px',
                                        borderRadius: '50%',
                                        backgroundColor: '#f8f9fa',
                                        border: '2px dashed #dee2e6',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        margin: '0 auto'
                                    }}>
                                        {profile.photo_url ? (
                                            <img src={profile.photo_url} alt="avatar" style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }} onError={(e)=>{e.currentTarget.style.display='none';}} />
                                        ) : (
                                            <i className="fa fa-user fa-3x text-muted"></i>
                                        )}
                                    </div>
                                </div>
                                <p className="text-muted mb-3">Cliquez pour sauvegarder</p>
                                <button className="btn btn-success rounded-pill px-4">
                                    <i className="fa fa-upload me-2"></i>Parcourir
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Account Details Section */}
                    <div className="col-md-6">
                        <div className="card border-0 shadow-sm" style={{borderRadius: '12px'}}>
                            <div className="card-header bg-transparent border-0">
                                <h6 className="fw-bold mb-0">Détails du compte</h6>
                            </div>
                            <div className="card-body p-4">
                                {profileError && (
                                    <div className="alert alert-danger" role="alert">{profileError}</div>
                                )}
                                <form onSubmit={(e)=>e.preventDefault()}>
                                    <div className="mb-3">
                                        <label className="form-label fw-semibold">Civilité *</label>
                                        <select className="form-select rounded-pill" value={profile.civility} onChange={(e)=>setProfile(p=>({...p, civility: e.target.value}))} disabled={loadingProfile}>
                                            <option value="">Sélectionnez</option>
                                            <option value="M.">M.</option>
                                            <option value="Mme">Mme</option>
                                            <option value="Mlle">Mlle</option>
                                        </select>
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label fw-semibold">Nom *</label>
                                        <input type="text" className="form-control rounded-pill" value={profile.name} onChange={(e)=>setProfile(p=>({...p, name: e.target.value}))} disabled={loadingProfile} />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label fw-semibold">Nom d'utilisateur</label>
                                        <div className="input-group">
                                            <span className="input-group-text rounded-start-pill"><i className="fa fa-user"></i></span>
                                            <input type="text" className="form-control rounded-end-pill" value={profile.username} onChange={(e)=>setProfile(p=>({...p, username: e.target.value}))} disabled={loadingProfile} />
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label fw-semibold">Email *</label>
                                        <div className="input-group">
                                            <span className="input-group-text rounded-start-pill"><i className="fa fa-envelope"></i></span>
                                            <input type="email" className="form-control rounded-end-pill" value={profile.email} onChange={(e)=>setProfile(p=>({...p, email: e.target.value}))} disabled={loadingProfile} />
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label fw-semibold">Téléphone</label>
                                        <div className="input-group">
                                            <span className="input-group-text rounded-start-pill">🇸🇳 +221</span>
                                            <input type="tel" className="form-control" value={profile.phone} onChange={(e)=>setProfile(p=>({...p, phone: e.target.value}))} disabled={loadingProfile} />
                                            <button type="button" className="btn btn-outline-secondary rounded-end-pill">Cacher</button>
                                        </div>
                                    </div>
                                    <div className="d-grid">
                                        <button type="submit" className="btn btn-success rounded-pill" disabled={loadingProfile}>
                                            <i className="fa fa-save me-2"></i>Sauvegarder
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccountPage;
